import React, { useState } from "react";
import { connectWisdomWallet, ensureWisdomChainForContract } from "../../chain";
import "../../styles/EarnRewards.css";

const EarnRewards = () => {
    const [rewards, setRewards] = useState([
        "Completed Course Reward: 10 WSD", 
        "Mentor Bonus: 5 WSD",
        "Quiz Completion Bonus: 2 WSD"
    ]);
    const [message, setMessage] = useState("");
    const [walletAddress, setWalletAddress] = useState("");
    const [isClaiming, setIsClaiming] = useState(false);

    // Check wallet connection on component mount
    React.useEffect(() => {
        const checkWallet = () => {
            const account = localStorage.getItem("user");
            if (account) {
                setWalletAddress(account);
            }
        };
        checkWallet();
    }, []);

    // This function maintains the safety guard but shows a user-friendly message
    const handleClaimRewards = async () => {
        if (!window.ethereum) {
            setMessage("MetaMask is required to claim rewards.");
            return;
        }

        try {
            // Connect wallet if not already connected
            let account = walletAddress;
            if (!account) {
                account = await connectWisdomWallet();
                setWalletAddress(account);
            }

            // Refuse placeholder contracts and force the Wisdom chain before any
            // tx — never a mainnet send (REACH-1337).
            await ensureWisdomChainForContract("0xWisdomTokenContractAddress");
            
            // In a real implementation, you would:
            // 1. Call the smart contract to claim rewards
            // 2. Handle the transaction
            // 3. Update the user's balance
            setMessage(`Successfully initiated reward claim. Please confirm the transaction in MetaMask.`);
            setIsClaiming(true);
            
            // Simulate reward claiming process
            setTimeout(() => {
                setMessage(`Rewards claimed successfully! Check your balance.`);
                setIsClaiming(false);
            }, 2000);
            
        } catch (error) {
            console.error("Error claiming rewards:", error);
            setMessage(error?.message || "An error occurred while claiming rewards.");
            setIsClaiming(false);
        }
    };

    return (
        <div className="earn-rewards">
            <h1>Earn Rewards</h1>
            <p>Complete courses and mentoring to earn WSD tokens.</p>
            
            {walletAddress && (
                <div className="wallet-info">
                    <p>Connected wallet: <strong>{walletAddress.substring(0, 6)}...{walletAddress.substring(walletAddress.length - 4)}</strong></p>
                </div>
            )}

            <div className="rewards-list">
                <h3>Reward Opportunities</h3>
                <ul>
                    {rewards.map((reward, index) => (
                        <li key={index}>{reward}</li>
                    ))}
                </ul>
            </div>

            <div className="claim-section">
                <button 
                    onClick={handleClaimRewards} 
                    disabled={isClaiming}
                    className="claim-button"
                >
                    {isClaiming ? "Processing Claim..." : "Claim Rewards"}
                </button>
            </div>

            {message && <p className="message">{message}</p>}
            
            <div className="info-section">
                <h3>How It Works</h3>
                <ul>
                    <li>Rewards are earned by completing platform activities</li>
                    <li>Rewards are distributed as WSD tokens on the Wisdom blockchain</li>
                    <li>Claim rewards using your connected MetaMask wallet</li>
                    <li>Rewards are automatically credited to your account</li>
                </ul>
            </div>
        </div>
    );
};

export default EarnRewards;